<template>
  <div class="checkbox-group">
    <div v-for="option in options" :key="option.id" class="base-checkbox">
      <input
        :id="getOptionId(option.id)"
        v-model="selected"
        type="checkbox"
        :name="name"
        :value="option.value"
        class="visually-hidden"
      >
      <label :for="getOptionId(option.id)">
        <slot name="checkmark" :option="option">
          <div class="checkbox">
            <check-icon size="14" stroke-width="4" />
          </div>
        </slot>
        <div class="ml-2" v-text="option.label" />
      </label>
    </div>
  </div>
</template>

<script>
import { CheckIcon } from '@bit/vekenkaluste.veke-ui.icons'

export default {
  name: 'CheckboxGroup',
  components: {
    CheckIcon
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    name: {
      type: String,
      required: true,
      default: ''
    },
    options: {
      type: Array,
      required: true
    }
  },
  emits: ['update:modelValue'],
  data () {
    return {
      selected: this.$attrs.modelValue
    }
  },
  watch: {
    selected () {
      if (!this.$attrs.disabled) {
        this.$emit('update:modelValue', this.selected)
      }
    }
  },
  methods: {
    getOptionId (id) {
      return this.$attrs.id ? `${this.$attrs.id}_${id}` : id
    }
  }
}
</script>

<style lang="scss">
.checkbox-group {
  @apply grid grid-flow-row gap-4;
}
.base-checkbox {
  @apply h-6;

  input {
    &:disabled + label {
      filter: saturate(0) brightness(0.95);
    }
    &:checked + label > .checkbox {
      @apply bg-turquoise border-turquoise;
      > svg {
        stroke-dashoffset: 60;
      }
    }
    &:focus-visible + label > .checkbox {
      @apply shadow-md border-turquoise;
    }
  }

  label {
    @apply inline-flex items-center cursor-pointer font-display antialiased leading-none tracking-wide select-none text-14;
    .checkbox {
      @apply inline-grid place-content-center self-start p-1 w-6 h-6 border rounded bg-white text-white overflow-hidden;
      > svg {
        transition: all 300ms;
        stroke-dasharray: 30;
        stroke-dashoffset: 30;
      }
    }
  }
}
</style>
